export default __webpack_public_path__ + "static/media/AdminLightInActive.525a1253.svg";